var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinibus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,15.1c0.2-1.1-0.6-2.1-1.7-2c-1,0.1-1.6,1-1.5,1.9l0,0H7.3c0.2-0.9-0.4-1.9-1.5-2c-1.1-0.1-1.9,0.9-1.7,2 H1l0.1-1.8l0.2-2.4l0.2-3.1c0-0.3,0.3-0.5,0.5-0.5l12.7,0.1c1,0,2,0.3,2.8,0.9l0.3,0.2l3.4,2.4c0.2,0.1,0.4,0.3,0.6,0.5 c0.7,0.7,1,1.6,1.1,2.5l0,1.1C23,15.1,21.7,15.1,21.7,15.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f00"
    },
    points: "1.7,10.9 1.3,10.9 1.3,11.6 1.7,11.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f00"
    },
    points: "1.2,12 1.1,13.4 1.7,13.4 1.7,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f00"
    },
    points: "1.7,11.6 1.3,11.6 1.2,12 1.7,12  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.4,13.4L11.4,13.4c-0.1,0-0.1,0-0.1-0.1v-1.1c0-0.1,0-0.1,0.1-0.1l0,0c0.1,0,0.1,0,0.1,0.1v1.1 C11.6,13.3,11.5,13.4,11.4,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.6,13.4L7.6,13.4c-0.1,0-0.1,0-0.1-0.1v-1.1c0-0.1,0-0.1,0.1-0.1l0,0c0.1,0,0.1,0,0.1,0.1v1.1 C7.7,13.3,7.7,13.4,7.6,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.8,13.2L16.8,13.2c-0.1,0-0.1,0-0.1-0.1V12c0-0.1,0-0.1,0.1-0.1l0,0c0.1,0,0.1,0,0.1,0.1v1.1 C16.9,13.1,16.9,13.2,16.8,13.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 9.1,
    style: {
      fill: "#000"
    },
    width: 3.7,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.6,9.4L14.6,9.4c-0.1-0.1-0.2-0.2-0.3-0.3h-3.5v2.5h4.6C14.8,9.8,14.8,9.7,14.6,9.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 9.1,
    style: {
      fill: "#000"
    },
    width: 4.4,
    height: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.5,11.6h-4.7l-0.8-3h2.2C17.9,9.2,19.8,10.9,20.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.9,11.6h-0.4C21.4,11.5,18,9,17.9,8.9V8.6C21.6,11.3,21.5,11.2,21.9,11.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.9,11.7c0,0.8,0,2.1,0,2.6c0-0.4,0-1.2,0-2C10.8,12.1,10.9,11.9,10.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.4,11.7c0,0.8,0,2.1,0,2.6c0-0.4,0-1.2,0-2C15.4,12.1,15.4,11.9,15.4,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,13.9c-0.6-0.2-1-0.6-1.3-1.2h0.3c0.5,0,0.9,0.4,1,0.8L23,13.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.2,15c0,0.9-0.7,1.7-1.7,1.7S3.8,15.9,3.8,15s0.7-1.7,1.7-1.7S7.2,14.1,7.2,15z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.5,
    cy: 15,
    r: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.9,14.9c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7s0.7-1.7,1.7-1.7C21.2,13.2,21.9,14,21.9,14.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,14.9c0,0.5-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S21.2,14.4,21.2,14.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.8,14.9c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6C20.6,14.3,20.8,14.6,20.8,14.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.9,11.9l-0.4,0l0.2-1.3l0,0c0.4,0,0.7,0.4,0.7,0.7l0,0C20.4,11.7,20.1,11.9,19.9,11.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibus);
export default __webpack_public_path__ + "static/media/minibus.f035c26baa7c9678f75c2d9ae5af6edd.svg";
export { ForwardRef as ReactComponent };